<template>
  <el-form
    ref="formValidate"
    :model="params"
    label-position="right"
    label-width="180px"
    :rules="rules"
  >
    <el-form-item prop="dstName" :label="$t('dstConfig.dstName')">
      <el-row>
        <el-col :span="22">
          <el-input type="text" v-model="params.id" v-if="false"> </el-input>
          <el-input
            type="text"
            v-model="params.dstName"
            :placeholder="$t('dstConfig.dstNameRequire')"
          >
          </el-input>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item prop="timezone" :label="$t('dstConfig.timezone')">
      <el-row>
        <el-col :span="22">
          <el-input
            type="text"
            v-model="params.timezone"
            :placeholder="$t('dstConfig.timezoneRequire')"
          ></el-input>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item prop="startTime" :label="$t('dstConfig.startTime')">
      <el-row>
        <el-col :span="22">
          <el-date-picker
            v-model="params.startTime"
            type="datetime"
            :placeholder="$t('dstConfig.startTimeRequire')"
            style="width:100%"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-col>
      </el-row>
    </el-form-item>

    <el-form-item prop="endTime" :label="$t('dstConfig.endTime')">
      <el-row>
        <el-col :span="22">
          <el-date-picker
            v-model="params.endTime"
            type="datetime"
            :placeholder="$t('dstConfig.endTimeRequire')"
            style="width:100%"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-col>
      </el-row>
    </el-form-item>

    <el-form-item prop="startYear" :label="$t('dstConfig.startYear')">
      <el-row>
        <el-col :span="22">
          <el-input
            type="number"
            v-model="params.startYear"
            :placeholder="$t('dstConfig.startYearRequire')"
          >
          </el-input>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item prop="endYear" :label="$t('dstConfig.endYear')">
      <el-row>
        <el-col :span="22">
          <el-input
            type="number"
            v-model="params.endYear"
            :placeholder="$t('dstConfig.endYearRequire')"
          >
          </el-input>
        </el-col>
        <el-col :span="2" align="center">
          <el-popover placement="right" width="282" trigger="hover">
            <div>{{ $t('dstConfig.endTimeDesc') }}</div>
            <i class="el-icon-question icon_tips_cla" slot="reference"></i>
          </el-popover>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item prop="active" :label="$t('dstConfig.active')">
      <el-radio v-model="params.active" :label="1">{{
        $t('device.enableStatus')
      }}</el-radio>
      <el-radio v-model="params.active" :label="0">{{
        $t('device.disbaleDevice')
      }}</el-radio>
    </el-form-item>
  </el-form>
</template>
<script>
import * as dstConfigApi from '@/services/dstConfigApi.js'
export default {
  name: 'zk-DST-save-or-update',
  props: ['form', 'isUpdate'],
  data() {
    let rules = {
      dstName: [
        {
          required: true,
          message: this.$t('dstConfig.dstNameRequire'),
          trigger: 'blur'
        }
      ],
      timezone: [
        {
          required: true,
          message: this.$t('dstConfig.timezoneRequire'),
          trigger: 'blur'
        }
      ],
      startTime: [
        {
          required: true,
          message: this.$t('dstConfig.startTimeRequire'),
          trigger: 'blur'
        }
      ],
      endTime: [
        {
          required: true,
          message: this.$t('dstConfig.endTimeRequire'),
          trigger: 'blur'
        }
      ],
      startYear: [
        {
          required: true,
          message: this.$t('dstConfig.startYearRequire'),
          trigger: 'blur'
        }
      ]
      // endYear: [{ required: true, message: this.$t('dstConfig.endYearRequire'), trigger: 'blur' }]
    }
    return {
      params: JSON.parse(JSON.stringify(this.form || {})),
      rules
    }
  },
  methods: {
    save() {
      let _self = this
      return new Promise((resolve, reject) => {
        this.$refs.formValidate.validate(valid => {
          if (valid) {
            // 处理时间
            if (!_self.isUpdate) {
              resolve(dstConfigApi.addDstConfig(_self.params))
            } else {
              resolve(dstConfigApi.updateDstConfig(_self.params))
            }
          } else {
            reject(valid)
          }
        })
      })
    },
    resetFields() {
      this.$refs.formValidate.resetFields()
    }
  },
  watch: {
    form(newValue, oldValue) {
      this.params = JSON.parse(JSON.stringify(newValue || oldValue))
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/styles/var.less';
.icon_tips_cla {
  color: @themeColor;
}
</style>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/dstSaveOrUpdate/src/main.vue